import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
 import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
import Bloglist from "./pages/Bloglist";
 
import Addblog from "./pages/Addblog";
 
import ViewEnq from "./pages/ViewEnq";
 import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
 
 import ViewBooking from "./pages/ViewBooking";
import { useEffect, useState } from "react";
import AddCourse from "./pages/AddCourse";
import CourseList from "./pages/CourseList";
import AddEvent from "./pages/AddEvent";
import EventList from "./pages/EventList";
import Bookings from "./pages/Bookings";
import CourseRequests from "./pages/CourseRequests";
import ViewCourseRequest from "./pages/ViewCourseRequest";

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay (e.g., fetching initial data)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust the timeout as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>

            {loading ? (
         <div className="loading-overlay">
         <div className="spinner"></div>
       </div>
           ) : (
      <>
 
      <Routes>
        <Route path="/" element={<OpenRoutes><Login /></OpenRoutes>} />
        <Route path="/admin" element={<PrivateRoutes><MainLayout /></PrivateRoutes>}>
          <Route index element={<CourseList />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="enquiries/:id" element={<ViewEnq />} />

          <Route path="bookings" element={<Bookings />} />
          <Route path="bookings/:id" element={<ViewBooking />} />

          <Route path="blog-list" element={<Bloglist />} />
          <Route path="blog" element={<Addblog />} />
          <Route path="course" element={<AddCourse />} />
          <Route path="course/:id" element={<AddCourse />} />

          <Route path="course-list" element={<CourseList />} />
          <Route path="course-requests" element={<CourseRequests />} />
          <Route path="course-requests/:id" element={<ViewCourseRequest />} />

          <Route path="event" element={<AddEvent />} />
          <Route path="event/:id" element={<AddEvent />} />

          <Route path="event-list" element={<EventList />} />

 
  
           <Route path="blog/:id" element={<Addblog />} />
         

 
        </Route>
      </Routes>
      </>)}
    </Router>
  );
}

export default App;
